__turbopack_context__.v({
  "body": "profileItem-module-scss-module__pEF8Aq__body",
  "button": "profileItem-module-scss-module__pEF8Aq__button",
  "companyName": "profileItem-module-scss-module__pEF8Aq__companyName",
  "description": "profileItem-module-scss-module__pEF8Aq__description",
  "logo": "profileItem-module-scss-module__pEF8Aq__logo",
  "logoWrapper": "profileItem-module-scss-module__pEF8Aq__logoWrapper",
  "profileGridType": "profileItem-module-scss-module__pEF8Aq__profileGridType",
  "profileListType": "profileItem-module-scss-module__pEF8Aq__profileListType",
});
